import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './styles/globals.css';
import App from './App.constants';
import * as serviceWorker from './serviceWorker';
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN || '',
    integrations: [
        new Sentry.BrowserTracing(),
        new Sentry.Replay(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: process.env.REACT_APP_SENTRY_ENVIRONMENT == 'production' ? 1.0 : 0.7,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: process.env.REACT_APP_SENTRY_ENVIRONMENT == 'production' ? 1.0 : 0.7,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
    enabled: ['development', 'production'].includes(process.env.REACT_APP_SENTRY_ENVIRONMENT),
});

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
